import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Events.css';
import eventsData from '../data/events.json';
import { useContent } from '../contexts/ContentContext';

const Events = () => {
  const { getSection } = useContent();
  const data = getSection<typeof eventsData>('events', eventsData);
  const { events } = data;
  const navigate = useNavigate();

  const handleViewAllEvents = () => {
    navigate('/events');
  };

  return (
    <section id="events" className="events-section">
      <div className="events-container">
        <div className="section-header">
          <h2 className="section-title">Our Events Timeline</h2>
          <p className="section-subtitle">
            Discover the amazing events and activities we've organized throughout the year
          </p>
          <div className="section-actions">
            <button 
              className="btn-view-all"
              onClick={handleViewAllEvents}
            >
              View All Events
            </button>
          </div>
        </div>

        <div className="timeline-container">
          <div className="timeline-line"></div>
          
          {events.map((event, index) => (
            <div 
              key={event.id} 
              className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
            >
              <div className="timeline-dot">
                <div className="dot-inner"></div>
              </div>
              
              <div className="event-card">
                <div className="event-header">
                  <div className="event-info">
                    <h3 className="event-title">{event.title}</h3>
                  </div>
                </div>
                
                <div className="event-description-box">
                  <div className="description-content">
                    <p>{event.description}</p>
                  </div>
                </div>
                
                <div className="event-actions">
                  <button className="btn-learn">Learn More</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Events;